import React from 'react';
import NumberFormat, { NumberFormatProps } from 'react-number-format';
import { Input, Props as InputProps } from './Input';

export interface Props
  extends NumberFormatProps,
    Omit<InputProps, 'defaultValue' | 'type' | 'value' | 'label'> {
  label?: React.ReactNode;
}

export const InputNumberMask = React.forwardRef<HTMLInputElement, Props>((props, ref) => {
  return <NumberFormat getInputRef={ref} customInput={Input} {...props} />;
});

InputNumberMask.defaultProps = {
  // eslint-disable-next-line react/default-props-match-prop-types
  thousandSeparator: true,
};
